import { dateTimeMinuteFormatter } from '@dreryk/react-common';

import { StyledDate } from './DateUpdatedText.styled';

type DateUpdatedTextProps = {
   date: Date | null;
};

export const DateUpdatedText = (props: DateUpdatedTextProps): JSX.Element => (
   <StyledDate testId={'dateUpdated'}>{dateTimeMinuteFormatter(props.date)}</StyledDate>
);
